/** Attach Naturals portal cookie auth to salon-admin and engagement API fetches. */
import { PORTAL_HEADER } from './storage';

const ENGAGEMENT_API_PREFIX = '/naturals-engagement-api';

export function installNaturalsPortalFetchInterceptor(portalId, adminApiBase) {
  if (typeof window === 'undefined' || !portalId) return () => {};
  const adminBase = String(adminApiBase || '').replace(/\/+$/, '');
  const orig = window.fetch.bind(window);
  window.fetch = (input, init = {}) => {
    const url = typeof input === 'string' ? input : input?.url || '';
    if (typeof url !== 'string') return orig(input, init);
    const needsPortal =
      (adminBase && url.startsWith(adminBase)) || url.includes(ENGAGEMENT_API_PREFIX);
    if (!needsPortal) return orig(input, init);
    const headers = new Headers(init.headers || {});
    headers.set(PORTAL_HEADER, portalId);
    return orig(input, { ...init, headers, credentials: init.credentials || 'include' });
  };
  return () => {
    window.fetch = orig;
  };
}
